<section>
    <div class="uscb-layout-row uscb-bg-primary uscb-color-white">
        <span class="vcenter uscb-flex uscb-padding-TB-0 uscb-padding-LR-10">{{ackDialogData.title}}</span>
        <span class="vcenter">
            <mat-icon (click)="close(true)" (keyup.enter)="close(true)" tabindex="0" aria-hidden="false">close</mat-icon>
        </span>
    </div>

    <mat-dialog-content>
        <div class="my-dialog-content">
            <p class="mat-body-1">{{ackDialogData.content}}</p>
        </div>
    </mat-dialog-content>

    <mat-dialog-actions class="uscb-layout-row uscb-layout-align-center-center">
        <button class="uscb-primary-button" (click)="ack()" (keyup.enter)="ack()" tabindex="0">{{ackDialogData.ackButtonLabel}}</button>
    </mat-dialog-actions>
</section>